import { useEffect } from "react";
import { analytics } from "@/lib/analytics";

export function useMenuTracking({ enabled, lang, active, sections, itemsById, query, resultCount }) {
  useEffect(() => {
    if (!enabled) return undefined;
    analytics.start(lang);
    return () => analytics.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  useEffect(() => {
    analytics.setLang(lang);
  }, [lang]);

  useEffect(() => {
    analytics.setActiveCategory(active || null);
  }, [active]);

  useEffect(() => {
    if (!enabled) return undefined;
    const timers = new Map();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        const key = en.target.dataset.anchor;
        if (en.isIntersecting) {
          timers.set(key, setTimeout(() => {
            if (key.startsWith("item-")) {
              const id = key.slice(5);
              analytics.impression(id, itemsById[id]?.category_id);
            } else {
              analytics.categoryView(key.slice(4));
            }
          }, 800));
        } else {
          clearTimeout(timers.get(key));
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll("[data-anchor]").forEach((el) => io.observe(el));
    return () => {
      io.disconnect();
      timers.forEach(clearTimeout);
    };
  }, [enabled, sections, itemsById]);

  useEffect(() => {
    if (!enabled) return undefined;
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0) analytics.scroll(Math.round((100 * window.scrollY) / h));
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [enabled]);

  useEffect(() => {
    if (!enabled || !query.trim()) return undefined;
    const id = setTimeout(() => analytics.search(query, resultCount), 1200);
    return () => clearTimeout(id);
  }, [enabled, query, resultCount]);
}
